var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/macros/product-quantity-dropdown.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["id", "class", "dataAttributes", "desiredQuantity", "startingIndex", "max"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("id", kwargs.hasOwnProperty("id") ? kwargs["id"] : "");
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("dataAttributes", kwargs.hasOwnProperty("dataAttributes") ? kwargs["dataAttributes"] : "");
frame.set("desiredQuantity", kwargs.hasOwnProperty("desiredQuantity") ? kwargs["desiredQuantity"] : 1);
frame.set("startingIndex", kwargs.hasOwnProperty("startingIndex") ? kwargs["startingIndex"] : 1);
frame.set("max", kwargs.hasOwnProperty("max") ? kwargs["max"] : 25);
var t_2 = "";var t_3;
t_3 = (lineno = 13, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.selectedSku.sku"]));
frame.set("selectedProductSku", t_3, true);
if(frame.topLevel) {
context.setVariable("selectedProductSku", t_3);
}
if(frame.topLevel) {
context.addExport("selectedProductSku", t_3);
}
var t_4;
t_4 = (lineno = 14, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "selectedProductSku"),"stockLevel",0]));
frame.set("inStockQuantity", t_4, true);
if(frame.topLevel) {
context.setVariable("inStockQuantity", t_4);
}
if(frame.topLevel) {
context.addExport("inStockQuantity", t_4);
}
var t_5;
t_5 = (lineno = 15, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "selectedProductSku"),"backorder",1]));
frame.set("backorderQuantity", t_5, true);
if(frame.topLevel) {
context.setVariable("backorderQuantity", t_5);
}
if(frame.topLevel) {
context.addExport("backorderQuantity", t_5);
}
var t_6;
t_6 = (lineno = 16, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "selectedProductSku"),"isDropShip",false]));
frame.set("isDropShip", t_6, true);
if(frame.topLevel) {
context.setVariable("isDropShip", t_6);
}
if(frame.topLevel) {
context.addExport("isDropShip", t_6);
}
var t_7;
t_7 = (runtime.contextOrFrameLookup(context, frame, "isDropShip")?(runtime.contextOrFrameLookup(context, frame, "backorderQuantity") + runtime.contextOrFrameLookup(context, frame, "inStockQuantity")):(runtime.contextOrFrameLookup(context, frame, "inStockQuantity") || runtime.contextOrFrameLookup(context, frame, "backorderQuantity")));
frame.set("availableQuantity", t_7, true);
if(frame.topLevel) {
context.setVariable("availableQuantity", t_7);
}
if(frame.topLevel) {
context.addExport("availableQuantity", t_7);
}
var t_8;
t_8 = (runtime.contextOrFrameLookup(context, frame, "wishlist") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showRegistryQuantity") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isGiftCard"))?runtime.contextOrFrameLookup(context, frame, "max"):(lineno = 20, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.pdpOptions.max_quantity_limit",10])));
frame.set("dropDownMax", t_8, true);
if(frame.topLevel) {
context.setVariable("dropDownMax", t_8);
}
if(frame.topLevel) {
context.addExport("dropDownMax", t_8);
}
var t_9;
t_9 = (lineno = 21, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_min"), "_min", context, [runtime.contextOrFrameLookup(context, frame, "availableQuantity"),runtime.contextOrFrameLookup(context, frame, "dropDownMax")]));
frame.set("maxOrderQuantity", t_9, true);
if(frame.topLevel) {
context.setVariable("maxOrderQuantity", t_9);
}
if(frame.topLevel) {
context.addExport("maxOrderQuantity", t_9);
}
var t_10;
t_10 = (lineno = 22, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_min"), "_min", context, [runtime.contextOrFrameLookup(context, frame, "desiredQuantity"),runtime.contextOrFrameLookup(context, frame, "maxOrderQuantity")]));
frame.set("selectedValue", t_10, true);
if(frame.topLevel) {
context.setVariable("selectedValue", t_10);
}
if(frame.topLevel) {
context.addExport("selectedValue", t_10);
}
t_2 += "\n    <select\n        id=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
t_2 += "\"\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
t_2 += " aria-describedby=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
t_2 += "_error\"";
;
}
t_2 += "\n        class=\"c-form__select ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "class"), env.opts.autoescape);
t_2 += "\"\n        ";
if(runtime.contextOrFrameLookup(context, frame, "dataAttributes")) {
t_2 += " ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "dataAttributes"), env.opts.autoescape);
;
}
t_2 += ">\n\n        ";
frame = frame.push();
var t_13 = (lineno = 29, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [runtime.contextOrFrameLookup(context, frame, "startingIndex"),runtime.contextOrFrameLookup(context, frame, "dropDownMax") + 1]));
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("index", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
t_2 += "\n            <option data-qa-qty=\"";
t_2 += runtime.suppressValue(t_14, env.opts.autoescape);
t_2 += "\" ";
if(t_14 > runtime.contextOrFrameLookup(context, frame, "maxOrderQuantity")) {
t_2 += " disabled ";
;
}
else {
if(t_14 == runtime.contextOrFrameLookup(context, frame, "selectedValue")) {
t_2 += " selected ";
;
}
;
}
t_2 += ">\n                ";
t_2 += runtime.suppressValue(t_14, env.opts.autoescape);
t_2 += "\n            </option>\n        ";
;
}
}
frame = frame.pop();
t_2 += "\n\n    </select>\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("productQuantityDropdown");
context.setVariable("productQuantityDropdown", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/macros/product-quantity-dropdown.j2"] , dependencies)